import styled from "styled-components";

export const Title1 = styled.h1`
  color: #161414;
  font-size: 18px;
  display: block;
  margin: 0;
  font-weight: ${({ weight }) => weight || 400};
  text-align: ${({ align }) => align || 'left'};
`;

export const Title2 = styled(Title1)`
  font-size: 16px;
`;

export const Regular = styled.p`
  font-size: 14px;  
  font-weight: ${({ weight }) => weight || 400};
  text-align: ${({ align }) => align || 'left'};

  .semibold {
    font-weight: 500;
  }
`

export const Support = styled(Regular)`
  margin-top: 16px;
  text-align: center;
  font-size: 10px;
  line-height: 18px;
  color: #707070;

  a {
    color: #707070;
  }
`
